<template lang="html">
  <div class="col-12">
    <div>
      <LoginTabs selected-page="register" />
      <form class="form-create-login">
        <div v-if="!$store.state.accountLink">
          <div class="form-group">
            <GfInput
              type="email"
              place-holder="Email"
              :has-error="validation.hasError('data_register.email')"
              :error-text="validation.firstError('data_register.email')"
              initial-field-value=""
              @valueChanged="val => (data_register.email = val)"
            />
          </div>
          <div class="form-group">
            <GfInput
              type="password"
              place-holder="Password"
              :has-error="validation.hasError('data_register.password')"
              :error-text="validation.firstError('data_register.password')"
              initial-field-value=""
              @valueChanged="val => (data_register.password = val)"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col pr-2">
              <label
                for="firstName"
                style="display:none"
              >First Name</label>
              <input
                id="firstName"
                v-model="data_register.firstName"
                type="text"
                class="form-control"
                placeholder="First Name"
              >
            </div>
            <div class="col pl-2">
              <label
                for="lastName"
                style="display:none"
              >Last Name</label>
              <input
                id="lastName"
                v-model="data_register.lastName"
                type="text"
                class="form-control"
                placeholder="Last Name"
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-12 col-md-4 col-sm-6 col-4 pr-md-0">
              <label class="opacity-80 mr-3 mt-1">Date of Birth:</label>
            </div>
            <div class="col-12 col-md-8 col-sm-6 et_pickedDate">
              <date-dropdown
                v-model="data_register.dateOfBirth"
                min="1920"
                class="float-left float-sm-right"
                max="2018"
                default="1991-01-01"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="m-auto text-center text-danger pt-2">
            <h5 v-if="serverMessage !== ''">
              {{ serverMessage }}
            </h5>
          </div>
        </div>
        <div class="row mx-0 px-0 mb-3 container">
          <TermsConditions
            button-that-agrees-text="Logging in, Registering or Creating a page"
          />
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-8 m-auto">
              <button
                id="btn-submit"
                type="button"
                class="btn btn-block font-weight-bold btn-driver"
                :disabled="creatingPage || teamDetailsInValid()"
                @click="submit_form_signup"
              >
                <p class="d-inline align-middle font-weight-bold">
                  Register & Create
                </p>
              </button>
            </div>
            <Loader />
          </div>
        </div>
      </form>
    </div>
    <FacebookLogin
      v-if="!inApp && !$store.state.accountLink"
      :app-id="facebookAppId"
      :scope="facebookScope"
      action-type="RegisterUser"
    />
  </div>
</template>

<script>
import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);
import axios from "axios";
import qs from "qs";
import DateDropdown from "@gf/gf-vue-date-dropdown";
import LoginTabs from "../login/LoginTabs.vue";
import FacebookLogin from "../login/FacebookLogin.vue";
import Loader from "../inc/Loader.vue";
import TermsConditions from "./TermsConditions.vue";
import GfInput from "../inc/GfInput.vue";

export default {
	components: {
		DateDropdown,
		FacebookLogin,
		Loader,
		LoginTabs,
		TermsConditions,
		GfInput,
	},

	data() {
		return {
			data_register: {
				email: "",
				confirmEmail: "",
				password: "",
				firstName: "",
				lastName: "",
				dateOfBirth: "",
			},
			serverMessage: "",
			creatingPage: false,
			inApp: false,
		};
	},

	computed: {
		facebookAppId: {
			get: function () {
				return this.$store.state.facebookAppId;
			},
		},
		facebookScope: {
			get: function () {
				return this.$store.state.facebookScope;
			},
		},
	},

	watch: {
		data_register: {
			handler() {
				this.data_register.confirmEmail = this.data_register.email;
			},
			deep: true,
		},
		'$store.state.tokenErrorMessage': function() {
			this.serverMessage = this.$store.state.tokenErrorMessage.message;
		},
	},

	mounted() {
		var vm = this;
		this.$root.$on("loggedIn", this._onSuccessfulLogin);
		this.$root.$on("pageCreationFailed", (err) =>
			vm._onPageCreationFailed(err)
		);
		var ua = navigator.userAgent || navigator.vendor || window.opera;
		this.inApp = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
	},

	methods: {
		created() {
			var self = this;
			this.data_register.email = this.$store.state.login.email;
			this.data_register.firstName = this.$store.state.login.firstname;
			this.data_register.lastName = this.$store.state.login.lastname;
		},

		teamDetailsInValid: function () {
			if (this.$store.state.pageType !== "createTeam") return false;
			return (
				this.$store.state.details_team.teamTarget === "" ||
				this.$store.state.details_team.teamName === ""
			);
		},

		_onPageCreationFailed: function (err) {
			this.serverMessage = err;
			this.creatingPage = false;
		},

		_onSuccessfulLogin: function (username) {
			this.$store.commit("preUserLogin", username);
		},

		StatusCheckLogin(type) {
			this.$emit("StatusCheckLogin", type);
		},

		submit_form_signup() {
			var vm = this;
			this.$validate().then(function (success) {
				if (success) {
					vm.$root.$emit("creatingPage");
					vm.creatingPage = true;
					if (
						vm.$store.state.accountLink &&
						vm.$store.state.accessToken &&
						vm.$store.state.accessToken.length > 0
					) {
						vm.data_register.Provider = "facebook";
						vm.data_register.Data = vm.$store.state.accessToken;
					}
					axios
						.post(
							"/account/register?isPopup=true",
							vm.data_register,
							{
								headers: {
									"Content-Type": "application/json",
								},
							}
						)
						.then(function (res) {
							vm.$gfLogger.logInfo('after /account/register?isPopUp=true, res: ', res);
							if (
								res.status === 200 &&
								res.data &&
								!res.data.success
							) {
								vm.$root.$emit(
									"pageCreationFailed",
									res.data.message
								);

								if (res.data.showProviderButton && res.data.showProviderButton === true) {
									vm.$store.commit('setAccountLinkMode', false);
								}
								return;
							}
							if (
								res.status === 200 &&
								res.data.TempData === undefined
							) {
								vm.$store.commit('setIsRegister', true);
								vm.serverMessage = "";
								vm.$root.$emit("createFrp");
								return;
							}

							if (
								res.data.TempData["Status.Css"] &&
								res.data.TempData["Status.Css"].toLowerCase() ==
									"error"
							) {
								vm.$root.$emit(
									"pageCreationFailed",
									res.data.TempData["Status.Message"]
								);
							}
						})
						.catch(function (error) {
							vm.$gfLogger.logInfo('catch after /account/register?isPopUp=true, error: ', error);
							vm.$root.$emit(
								"pageCreationFailed",
								"An unknown error during page creation. Please contact support."
							);
						});
				}
			});
		},
	},

	validators: {
		"data_register.email": function (value) {
			if (!this.$store.state.accountLink)
				return Validator.value(value)
					.required()
					.email()
					.custom(function () {
						if (value && /['‘’]/.test(value)) {
							return "Apostrophes are not allowed in email addresses.";
						}
					});
		},
		"data_register.password": function (value) {
			if (!this.$store.state.accountLink)
				return Validator.value(value).required().minLength(9);
		},
	},
};
</script>

<style scoped>
.opacity-80 {
	opacity: 0.8;
}

.et_pickedDate .date-dropdown-container select {
	padding: 4px !important;
	opacity: 0.8;
}
.et_pickedDate
	.date-dropdown-container
	.date-dropdown-select-wrapper:last-child
	select {
	margin-right: 0px;
}
</style>
